import { initializeApp } from "firebase/app";
import { getMessaging, getToken, onMessage } from "firebase/messaging";
// import { FIREBASE_MESSAGING_PUBLIC_VAPID_KEY } from "../../../constants";
import axiosApiInstance from "../../../utils/axios";

export const firebaseMessaging = () => {
  const firebaseConfig = {
    apiKey: "AIzaSyD-RFmObuz6Ak0hVb_sdj3ZyP1a1dGjGbs",
    authDomain: "ar-dispensary.firebaseapp.com",
    databaseURL:
      "https://ar-dispensary-default-rtdb.europe-west1.firebasedatabase.app",
    projectId: "ar-dispensary",
    storageBucket: "ar-dispensary.appspot.com",
    messagingSenderId: "1055278210758",
    appId: "1:1055278210758:web:b5dffbe46ae719516841c7",
    measurementId: "G-B63FM65B66",
  };

  const app = initializeApp(firebaseConfig);
  const messaging = getMessaging(app);

  getToken(messaging, {
    vapidKey:
      "BGmyTq43Mg83HOZaUzmRhzl8u_GjbRA05vQ6vZL_yXryLU4qs0HP21meDibI3f5JDnN4GmtBT9lC5Igvrz57IcU",
  })
    .then((firebaseToken) => {
      if (firebaseToken) {
        // console.log("firebaseToken", firebaseToken);
        axiosApiInstance.put("/worker", { firebaseToken });
      } else {
        // Show permission request UI
        console.log(
          "No registration token available. Request permission to generate one."
        );
        // ...
      }
    })
    .catch((err) => {
      console.log("An error occurred while retrieving token. ", err);
      // ...
    });

  onMessage(messaging, (payload) => {
    console.log("[messaging.js] Received message ", payload);
    Notification.requestPermission().then((perm) => {
      if (perm === "granted") {
        const notificationTitle = payload.notification.title;
        const notificationOptions = {
          body: payload.notification.body,
          image: "/favicon.png",
          icon: "/favicon.png",
          badge: "/favicon.png",
          data: payload.data,
        };

        const notification = new Notification(
          notificationTitle,
          notificationOptions
        );

        notification.onclick = (event) => {
          event.preventDefault();
          window.location.href =
            event.target.data.isCollectibles === "true"
              ? "/orders"
              : "/brand/orders";
        };
      }
    });
  });
};
